<template>
    <div class="row center-xs title" v-bind:style="titleStyle">
        <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
            <h1 v-bind:style="titleStyle" >{{title}}</h1>
            <div class="separator" v-bind:style="separatorStyle"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Title",
        props: {
            title: {
                type: String,
                default: ''
            },
            backgroundColor: {
                type: String,
                default: '#F5F5F5'
            },
            textColor: {
                type: String,
                default: '#27348B'
            }
        },
        data() {
            return {
                titleStyle: {
                    'background-color': this.backgroundColor,
                    'color': this.textColor
                },
                separatorStyle: {
                    'background-color': this.textColor
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .separator {
        height: 0.4em;
        width: 2.4em;
        display: inline-block;
        margin-bottom: 0.8em;
    }

    .title {
        padding-top: 3em;
        padding-bottom: 3em;
    }

</style>
